const PublicityTraining = r => require.ensure([], () => r(require('@/page/publicity-training/PublicityTraining')), 'PublicityTraining');
const PublicityTrainingView = r => require.ensure([], () => r(require('@/page/publicity-training/PublicityTrainingView')), 'PublicityTrainingView');
// 必学设置
const trainingPlan = r => require.ensure([], () => r(require('@/page/publicity-training/trainingPlan')), 'trainingPlan');

const publicitytrainingRouter = {
    path: '',
    name: '宣传统计后台',
    component: PublicityTrainingView,
    meta: {
        right: [],
        isShowMenu: true,
        icon: 'organMge',
    },
    children: [
        {
            path: '/PublicityTraining',
            component: PublicityTraining,
            name: '宣传统计后台',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive: true,
            },
        },
        {
          path: '/trainingPlan',
          component: trainingPlan,
          name: '培训计划',
          meta: {
              right: [],
              isShowMenu: false,
              keepAlive: false,
          },
      },
    ]
};
export default publicitytrainingRouter;